import * as React from 'react'
import {
    OfferForm,
} from './PrismaRequestDetailsState'
import Dialog from 'material-ui/Dialog'
import { PrismaRequestDetailsAction } from './PrismaRequestDetailsActions'
import Button from 'material-ui-next/Button/Button'
import { TextField } from 'material-ui-next'

export function PrismaRequestDeclineOfferModal({state, dispatch}: {
    state: OfferForm,
    dispatch: (action: PrismaRequestDetailsAction) => void,
}) {
    return (
        <div>
            <Dialog
                title="Angebot abgeben"
                modal={true}
                open={state.isDeclineOfferModalOpen}
            >
                <div style={{width: '100%', boxSizing: 'border-box', padding: '8px'}}>
                    Möchen Sie die Anfrage wirklich ablehnen?<br/>
                    <br/>
                    <TextField
                        label="Kommentar"
                        value={state.declineComment}
                        fullWidth={true}
                        onChange={
                            (e) => dispatch(
                                {
                                    type: 'ChangeDeclineComment',
                                    offerType: state.prismaRequestOffer.type,
                                    comment: e.target.value,
                                },
                            )
                        }

                    />
                </div>
                <div
                    style={{
                        display: 'flex',
                        flexDirectionflexDirection: 'row',
                        justifyContent: 'space-between',
                        marginTop: '1em',
                    }}
                >
                    <Button
                        color="secondary"
                        raised={true}
                        onClick={
                            () => dispatch(
                                {
                                    type: 'CloseDeclineOfferModal',
                                    offerType: state.prismaRequestOffer.type,
                                },
                            )
                        }
                    >
                        Abbrechen
                    </Button>
                    <Button
                        style={{
                            color: '#fff'
                        }}
                        color="primary"
                        raised={true}
                        onClick={
                            () => {
                                dispatch(
                                    {
                                        type: 'DeclineOffer',
                                        offerType: state.prismaRequestOffer.type,
                                        comment: state.declineComment,
                                    },
                                )
                            }
                        }
                    >
                        Anfrage ablehnen
                    </Button>
                </div>
            </Dialog>
        </div>
    )
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/PrismaRequestDetails/PrismaRequestDeclineOfferModal.tsx